<template>
  <div class="windInfo_wrapper common_radius">
    <!-- <div class="windInfo_header">
      <span class="windInfo_header-item">
        <span class="label">开始日期：</span>
        <span class="value">{{ startDate }}</span>
      </span>
      <span class="windInfo_header-item">
        <span class="label">结束日期：</span>
        <span class="value">{{ endDate }}</span>
      </span>
    </div> -->
    <div class="windInfo_item-box">
      <div class="windInfo_item" v-for="(item, key) in dataArr" :key="key">
        <span class="windInfo_item-label">{{ item.label }}</span>
        <span class="sign">:</span>
        <span class="windInfo_item-value">{{ item.value }}</span>
      </div>
    </div>
    <el-table
      class="windInfo_table"
      :data="tableData"
      border
      style="width: 100%"
      :header-cell-style="{
        fontSize: '14px',
        fontWeight: 'bold',
        color: '#444455',
        backgroundColor: 'rgb(180, 211, 238)'
      }"
      :row-class-name="tableRowClassName"
    >
      <el-table-column prop="height" align="center" label="高度" width="70">
      </el-table-column>
      <el-table-column prop="avgWindSpeed" align="center" label="平均风速(m/s)">
      </el-table-column>
      <el-table-column
        prop="powerDensity"
        align="center"
        label="风功率密度(W/㎡)"
      >
      </el-table-column>
      <el-table-column
        prop="maxSpeed10m"
        align="center"
        label="观测最大值(m/s)"
      >
      </el-table-column>
      <el-table-column prop="maxSpeed3s" align="center" label="观测极大值(m/s)">
      </el-table-column>
      <el-table-column
        prop="extremeSpeed10m"
        align="center"
        label="50年一遇最大风速(m/s)"
      >
      </el-table-column>
      <el-table-column
        prop="extremeSpeed3s"
        align="center"
        label="50年一遇极大风速(m/s)"
      >
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
export default {
  data() {
    return {
      tableData: [],
      startDate: '',
      endDate: '',
      windInfo: {
        startDate: '开始日期',
        endDate: '结束日期',
        mainWindDirection: '最高高度主风向',
        mainPowerDirection: '最高高度主风能',
        altitude: '海拔高度(m)',
        airDensity: '空气密度(kg/m³)',
        avgTurbulence: '湍流(15m/s)',
        windShear: '综合风切变系数',
        avgTemperature: '平均温度(℃)',
        avgPressure: '平均气压(kPa)',
        maxTemperature: '最高温度(℃)',
        minTemperature: '最低温度(℃)',
        weibullA: '威布尔参数A',
        weibullK: '威布尔参数K'
      },
      dataArr: []
    };
  },
  computed: {
    versionId: function() {
      let versionId = '';
      let idString = this.$store.state.WindData.idString;
      if (idString) {
        let arr = idString.toString().split('-');
        versionId = arr[1];
      }
      return versionId;
    }
  },
  watch: {
    versionId: function(newVal, oldVal) {
      if (newVal && newVal != oldVal) {
        this.setup();
      }
    }
  },
  methods: {
    async setup() {
      if (!this.versionId) return;
      let res = await this.$fetch(
        '/winddata/WindAnalyze/getTowerVersionDetail',
        {
          module: 'windData',
          params: {
            versionId: this.versionId
          }
        }
      );
      if (res.code == 0) {
        let resdata = res.data;
        this.tableData = resdata.channelList;
        let towerOverview = resdata.towerOverview;
        if (towerOverview == null) {
          this.startDate = '';
          this.endDate = '';
          this.dataArr = [];
        } else {
          this.startDate = towerOverview.startDate;
          this.endDate = towerOverview.endDate;
          this.dataArr = this.getDataArr(towerOverview);
        }
      }
    },
    getDataArr(towerOverview) {
      let arr = [];
      for (let key in this.windInfo) {
        let label = this.windInfo[key];
        let value = towerOverview[key] || '';
        arr.push({ label, value });
      }
      return arr;
    },
    tableRowClassName({ row, rowIndex }) {
      console.log(row);
      if (rowIndex % 2 !== 0) {
        return 'custom-table-row-odd';
      } else {
        return 'custom-table-row-even';
      }
    }
  },
  mounted() {
    this.setup();
  }
};
</script>
<style lang="less" scoped>
.windInfo {
  &_wrapper {
    padding: 10px 10px 25px 10px;
    background: #fff;
  }
  &_header {
    height: 45px;
    background: #2f6ba44d;
    border-radius: 8px;
    line-height: 45px;
    padding-left: 15px;
    margin-bottom: 25px;
    &-item {
      display: inline-block;
      font-size: 16px;
      &:first-child {
        margin-right: 25px;
      }
      .label {
        color: #222233;
        font-weight: bold;
      }
      .value {
        color: #888899;
      }
    }
  }
  &_item {
    width: 400px;
    display: inline-block;
    margin-bottom: 25px;
    &-box {
      padding-left: 23px;
      margin-top: 20px;
    }
    &-label {
      font-size: 14px;
      color: #222233;
      font-weight: bold;
      width: 120px;
      display: inline-block;
      word-break: break-all;
      text-align: justify;
    }
    .sign {
      font-size: 14px;
      color: #222233;
      font-weight: bold;
      margin-right: 10px;
    }
    &-value {
      font-size: 14px;
      color: #888899;
    }
  }
}
</style>
